import type { StyleLayer } from './utils/types'

export const layers_roads_mainstreets_classified: StyleLayer[] = [
  {
    id: 'roadclassification_primary',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['primary', 'primary_link', 'secondary', 'tertiary', 'tertiary_link', 'secondary_link'],
      true,
      false,
    ],
    minzoom: 7.7,
    paint: {
      'line-color': [
        'match',
        ['get', 'road'],
        ['tertiary', 'tertiary_link'],
        '#cab007',
        ['secondary', 'secondary_link'],
        '#07b072',
        ['primary', 'primary_link'],
        '#1992f5',
        'red',
      ],
      'line-opacity': 0.4,
      'line-width': ['interpolate', ['linear'], ['zoom'], 6, 2, 12, 8],
    },
  },
  {
    id: 'roadclassification_motortrunk copy 2',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['motorway', 'motorway_link', 'trunk', 'trunk_link'],
      true,
      false,
    ],
    minzoom: 7.7,
    paint: {
      'line-color': '#828282',
      'line-width': ['interpolate', ['linear'], ['zoom'], 11, 1, 14, 1.5, 16, 2],
    },
  },
  {
    id: 'hitarea-roadclassification copy 2',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      [
        'primary',
        'tertiary_link',
        'secondary_link',
        'tertiary',
        'secondary',
        'primary_link',
        'trunk',
        'motorway_link',
        'motorway',
        'trunk_link',
      ],
      true,
      false,
    ],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
]
